/**
 * JSON-LD for a script body. Escapes characters that can close the script
 * element (JSON-LD in HTML, https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements).
 */
export const jsonLdHtml = (value: unknown): string =>
  JSON.stringify(value)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026');

/** Helmet `script` entry. `id` keeps each block when several share the same type. */
export const jsonLdHelmetScript = (id: string, value: unknown) => ({
  type: 'application/ld+json' as const,
  id,
  innerHTML: jsonLdHtml(value),
});
